import React, { FC, useEffect } from "react";
import { FieldArray } from "react-final-form-arrays";
import { useForm, useFormState } from "react-final-form";
import { ProgramType } from "../../../../constants";
import ProgramTypeInput from "../../../components/step1/ProgramTypeInput";
import ProgramDuration from "../../../components/step1/ProgramDuration";
import AssignBranches from "../../../components/step1/AssignBranches";
import HousingType from "../../../components/step1/HousingType";
import { Intakes } from "../../../components/step1/Intakes";
import { IStepTemplate } from "../../../types";

const Template: FC<IStepTemplate> = ({ stepName }) => {
  const formState = useFormState();
  const { change } = useForm();

  const programType = formState.values?.[stepName]?.programType;

  useEffect(() => {
    if (programType === ProgramType.ONLINE) {
      change(`${stepName}.housingTypes`, []);
    }
  }, [programType]);

  return (
    <>
      <ProgramTypeInput name={stepName} />
      <ProgramDuration name={stepName} />
      <FieldArray
        disabled={programType !== ProgramType.ON_CAMPUS}
        name={`${stepName}.housingTypes`}
        component={HousingType}
      />
      <Intakes stepName={stepName} />
      <FieldArray
        stepName={stepName}
        name={`${stepName}.branches`}
        component={AssignBranches}
      />
    </>
  );
};

export default Template;
